import { Lead } from '@otw/models';
import { normalizeText } from './customerUtils';

export interface TaskCustomerLeadSummary {
  id: string;
  company: string | null;
  createdAt: Date | null;
}

export interface TaskCustomerOption {
  /** Always the Firestore `contacts` document id. */
  id: string;
  displayName: string;
  email?: string | null;
  phone?: string | null;
  leads: TaskCustomerLeadSummary[];
}

export const getCustomerKeyForLead = (lead: Lead): string =>
  normalizeText(lead.email) ||
  normalizeText(lead.phone) ||
  normalizeText(lead.customerName) ||
  lead.id;

